import config from '../../../config.json';
import axios from 'axios';

import { EntityService } from '../../../service/EntityService';

export class SubscriptionService extends EntityService {
    constructor(){
        super('subscriptions');
    }

    getCurrentCustomer = async () => {
        return (await axios.get(`${config.BASE_URL}current-customer`)).data;
    }

    saveCurrentCustomer = async (customer) => {
        console.log("saveCurrentCustomer", customer)
        return (await axios.post(`${config.BASE_URL}current-customer`, customer)).data;
    }

    getCurrentSubscriptions = async () => {
        return (await axios.get(`${config.BASE_URL}current-subscription-plan`)).data;
    }

    subscribe = async (planId, tokens, deviceId, paymentMethod) => {
        return (await axios.post(`${config.BASE_URL}current-subscription-plan`,{ planId, tokens, deviceId, paymentMethod })).data;
    }

    getPaymentToken = async (planId) => {
        return (await axios.post(`${config.BASE_URL}payment-token`,{ id: planId })).data;
    }

    confirmSubscription = async (id) => {
        return (await axios.post(`${config.BASE_URL}confirm-subscription`,{ id })).data;
    }

    cancelSubscription = async (id) => {
        return (await axios.post(`${config.BASE_URL}cancel-subscription`,{ id })).data;
    }

    abortSubscription = async (id) => {
        return (await axios.post(`${config.BASE_URL}abort-subscription`,{ id })).data;
    }

    syncContaAzul = async () => {
        return (await axios.post(`${config.BASE_URL}job-contaazul`,{})).data;
    }
}